import React, { FC } from "react";
import { FinancialApplicationCreditReport } from "../../models/applications/applicationInterfaces";

interface CreditBureauCardProps {
  report: FinancialApplicationCreditReport;
  isSelected: boolean;
  onClick: () => void;
  formatDate: (dateString: string) => string | null;
}

export const CreditBureauCard: FC<CreditBureauCardProps> = ({
  report,
  isSelected,
  onClick,
  formatDate,
}) => {
  return (
    <div
      className="text-dark p-3"
      style={{
        width: "250px",
        border: isSelected ? "2px solid #00b4a1" : "1px solid #ededed",
        borderRadius: "8px",
        cursor: "pointer",
        backgroundColor: isSelected ? "#ffffff" : "#f8f9fa",
      }}
      onClick={onClick}
    >
      <div className="h5">{report.bureau}</div>
      <div
        className="text-uppercase"
        style={{ fontSize: "8pt", color: "#a2b0bc" }}
      >
        credit score
      </div>
      <div style={{ fontSize: "1.25rem", fontWeight: 600 }}>
        {report.score || "—"}
      </div>
      <div
        className="text-uppercase mt-2"
        style={{ fontSize: "8pt", color: "#a2b0bc" }}
      >
        received at
      </div>
      <div style={{ fontSize: "0.75rem" }}>{formatDate(report.receivedAt)}</div>
    </div>
  );
};

export default CreditBureauCard;
